<template>
  <div class="tablelist">
    <div class="row align--center">
    <div class="flex xs12 md4">
        <va-input :value="term" placeholder="To" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md4">
        <va-select
          v-model="StatusOptionsModel"
          textBy="description"
          placeholder="Estado"
          :options="this.StatusOptions"
          @change="search"
        />
      </div>
      <div class="flex xs12 md2 offset--md2">
        <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
      <template slot="attach" slot-scope="props">
        <img class="imgdata ma-0" :id="props.rowData.MailId" src="../../assets/images/detail.png" alt="Detalle del Correo" title="Detalle del Correo" width="20" @click="dataReg(props, 'Detail')" />
      </template>
      <template slot="status" slot-scope="props">
          <div v-if="props.rowData.MailStatus === 1">En Cola</div>
          <div v-else-if="props.rowData.MailStatus === 2">En Proceso</div>
          <div v-else-if="props.rowData.MailStatus === 3">Enviado</div>
          <div v-else-if="props.rowData.MailStatus === 4">Fallido</div>
      </template>
    </va-data-table>
    <div class="text-right">
      <button class="loginbtn primaryBtn" type="submit" v-on:click="exportExcel">
          <va-icon name="fa fa-download" size="60" /> Generar Reporte
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import XLSX from 'xlsx'

export default {
  name: 'ReportMail',
  data () {
    return {
      term: null,
      perPage: '20',
      perPageOptions: ['5', '10', '20', '50', '100'],
      StatusOptions: [
        {
          id: 1,
          description: 'En Cola',
        },
        {
          id: 2,
          description: 'En Proceso',
        },
        {
          id: 3,
          description: 'Enviado',
        },
        {
          id: 4,
          description: 'Fallido',
        },
      ],
      StatusOptionsModel: 0,
      users: this.InfoView,
      arrayReport: [],
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
    filterData: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1)) && (!this.StatusOptionsModel.id)) {
        return this.users
      }
      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.MailTo.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        if (this.StatusOptionsModel.id >= 1) {
          return item.MailStatus === this.StatusOptionsModel.id
        } else {
          return item
        }
      })
    },
  },
  methods: {
    exportExcel: function () {
      if (this.filteredData.length >= 1) {
        this.arrayReport.length = 0
        let loader = this.$loading.show()
        for (var i = 0; i < this.filteredData.length; i++) {
          var mailStado = ''
          if (this.filteredData[i].MailStatus === 1) {
            mailStado = 'En Cola'
          } else if (this.filteredData[i].MailStatus === 2) {
            mailStado = 'En Proceso'
          } else if (this.filteredData[i].MailStatus === 3) {
            mailStado = 'Enviado'
          } else {
            mailStado = 'Fallido'
          }

          this.arrayReport.push(
            {
              'ID': this.filteredData[i].MailId,
              'FROM': this.filteredData[i].MailFrom,
              'TO': this.filteredData[i].MailTo,
              'CC': this.filteredData[i].MailCc,
              'ASUNTO': this.filteredData[i].MailSubject,
              'DETALLE': this.filteredData[i].MailResponse,
              'FECHA': this.filteredData[i].MailSend,
              'ESTADO': mailStado,
            }
          )
        }

        var dateRef = new Date()
        var month = '' + (dateRef.getMonth() + 1)
        var day = '' + dateRef.getDate()
        if (month.length < 2) { month = '0' + month }
        if (day.length < 2) { day = '0' + day }
        const filename = 'CorreosIbero_' + day + month + dateRef.getFullYear()

        let data = XLSX.utils.json_to_sheet(this.arrayReport)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
        loader.hide()
      }
    },
    dataReg (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
ul.listUL {
  width: 300px !important;
  list-style-type: square;
}
</style>
